'use strict';

var _classCallCheck = require("C:\\Users\\mrcax\\WebstormProjects\\hth\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\mrcax\\WebstormProjects\\hth\\node_modules\\@babel\\runtime/helpers/createClass");

var fs = require('fs');

var url = require('url');

var http = require('http');

var https = require('https');

var Network =
/*#__PURE__*/
function () {
  function Network() {
    _classCallCheck(this, Network);

    this._protocols = {
      http: http,
      https: https
    };
  }

  _createClass(Network, [{
    key: "_request",
    value: function _request(options, callback) {
      var self = this;
      callback = callback || Function();

      var _url = url.parse(options.url ? options.url : options);

      var protocol = _url.protocol.substr(0, _url.protocol.length - 1);

      var port;
      if (_url.protocol === 'http:') port = 80;
      if (_url.protocol === 'https:') port = 443;

      if (options.port) {
        port = options.port;
      }

      if (_url.host === null) {
        callback(undefined, undefined, new Error());
        return;
      }

      if (typeof options === 'string') {
        var req_options = {
          host: _url.host,
          path: _url.pathname,
          port: port,
          method: options.method
        };
      } else {
        var queryStr = _url.query ? _url.query + '&' : '';

        if (options.query !== undefined) {
          queryStr += self._renderUrlencoded(options.query);
        }

        req_options = {
          host: _url.host,
          path: _url.pathname + (queryStr ? '?' + queryStr : ''),
          port: port,
          method: options.method,
          headers: options.headers,
          timeout: options.timeout
        };
      }

      var req = this._protocols[protocol].request(req_options, function (response) {
        if (options.pipe !== undefined) {
          response.pipe(options.pipe);
        }

        var chunks = [];
        response.on('data', function (chunk) {
          chunks.push(chunk);
        });
        response.on('end', function () {
          var data = Buffer.concat(chunks).toString('utf-8');

          if (options.json !== undefined && options.json == true) {
            try {
              var obj = JSON.parse(data);
            } catch (e) {
              callback(data, undefined, e);
              return;
            }

            callback(obj, response);
            return;
          } else {
            callback(data, response);
          }
        });
      });

      if (options.timeout) {
        req.setTimeout(options.timeout, function (e) {
          req.abort();
        });
      }

      if (req_options.method === 'POST' && options.multipart) {
        var data = options.multipart;
        var names = Object.keys(options.multipart);
        var boundaryKey = Math.random().toString(16);

        var body = this._renderMultipartBody(names, data, boundaryKey);

        var length = 0;
        req.setHeader('Content-Type', 'multipart/form-data; boundary="' + boundaryKey + '"');
        body.forEach(function (part) {
          length = length + Buffer.byteLength(part);
        });
        names.forEach(function (name) {
          if (data[name].value !== undefined) {
            length = length + self._getFilesizeInBytes(data[name].value.path);
          }
        });
        req.setHeader('Content-Length', length + 16 * (names.length - 1) + 8 + Buffer.byteLength(boundaryKey));

        this._sendMultipartParts(boundaryKey, body, data, names, req, 0);
      } else if (req_options.method == 'POST' && options.jsonData) {
        req.setHeader('Content-Type', 'application/json');
        var body = JSON.stringify(options.jsonData);
        req.setHeader('Content-Length', Buffer.byteLength(body));
        req.end(body);
      } else {
        if (req_options.method == 'POST' && options.form) {
          req.setHeader('Content-Type', 'application/x-www-form-urlencoded');

          var body = self._renderUrlencoded(options.form);

          req.setHeader('Content-Length', Buffer.byteLength(body));
          req.end(body);
        } else {
          req.setHeader('Content-Length', 0);
          req.end();
        }
      }

      req.on('error', function (e) {
        callback(undefined, undefined, e);
      });
    }
  }, {
    key: "_renderMultipartBody",
    value: function _renderMultipartBody(names, data, boundaryKey) {
      var body = [];
      names.forEach(function (name, i) {
        if (data[name].value !== undefined) {
          body[i] = '--' + boundaryKey + '\r\n' + 'Content-Type: ' + data[name].contentType + '\r\n' + 'Content-Disposition: form-data; name="' + name + '"; filename="' + data[name].filename + '"\r\n' + 'Content-Transfer-Encoding: binary\r\n\r\n';
        } else {
          body[i] = '--' + boundaryKey + '\r\n' + 'Content-Disposition: form-data; name="' + name + '"\r\n\r\n' + data[name];
        }
      });
      return body;
    }
  }, {
    key: "_sendMultipartParts",
    value: function _sendMultipartParts(boundaryKey, body, data, names, req, i) {
      var self = this;
      req.write('\r\n' + body[i]);

      if (data[names[i]].value !== undefined) {
        data[names[i]].value.on('end', function () {
          if (i + 1 <= names.length - 1) {
            req.write('\r\n--' + boundaryKey);

            self._sendMultipartParts(boundaryKey, body, data, names, req, i + 1);
          } else {
            req.end('\r\n--' + boundaryKey + '--');
          }
        }).pipe(req, {
          end: false
        });
      } else {
        if (i + 1 <= names.length - 1) {
          req.write('\r\n--' + boundaryKey);

          self._sendMultipartParts(boundaryKey, body, data, names, req, i + 1);
        } else {
          req.end('\r\n--' + boundaryKey + '--');
        }
      }
    }
  }, {
    key: "_getFilesizeInBytes",
    value: function _getFilesizeInBytes(filename) {
      return fs.statSync(filename).size;
    }
    /**
     * @param {object} query
     * @returns {string}
     * @private
     */

  }, {
    key: "_renderUrlencoded",
    value: function _renderUrlencoded(query) {
      var queryStr = '';

      for (var key in query) {
        if (queryStr != '') queryStr += '&';
        queryStr += key + '=' + encodeURIComponent(query[key]);
      }

      return queryStr;
    }
  }, {
    key: "get",
    value: function get(options, callback) {
      if (typeof options === 'string') {
        this._request({
          url: options,
          method: 'GET'
        }, callback);

        return;
      }

      options.method = 'GET';

      this._request(options, callback);
    }
  }, {
    key: "post",
    value: function post(options, callback) {
      if (typeof options === 'string') {
        this._request({
          url: options,
          method: 'POST'
        }, callback);

        return;
      }

      options.method = 'POST';

      this._request(options, callback);
    }
  }, {
    key: "put",
    value: function put(options, callback) {
      if (typeof options === 'string') {
        this._request({
          url: options,
          method: 'PUT'
        }, callback);

        return;
      }

      options.method = 'PUT';

      this._request(options, callback);
    }
  }]);

  return Network;
}();

module.exports = new Network();